import headerBase from '../header-commons/lib/header-base';
export default {
	extends: headerBase,
	el: '#pp-header',
	data: {
		menubarVisible: false
	}
};
